import React from 'react';
import { st, classes, cssStates } from '../VerticalTabsItem.st.css.js';
import { Affix } from './Affix';
import dataHooks from '../dataHooks';
import { Text } from '../..';
const SelectableItem = ({ children, dataHook, prefixIcon, suffixIcon, size, baseSkin, disabled, id, tabIndex, skin, selected, onChange, 'aria-controls': ariaControls, focusableOnFocus, focusableOnBlur, }) => {
    const onKeyDown = (e) => {
        if (e.key === 'Enter' && id !== undefined) {
            onChange?.(id);
        }
    };
    return (React.createElement("div", { className: st(classes.root, classes.selectableItem, cssStates({
            disabled,
            size,
            baseSkin,
            skin,
            suffixIcon: !!suffixIcon,
            prefixIcon: !!prefixIcon,
            selected,
        })), onFocus: focusableOnFocus, onBlur: focusableOnBlur, id: typeof id === 'number' ? String(id) : id, tabIndex: tabIndex, role: "tab", "aria-selected": selected, "data-hook": dataHook, "aria-controls": ariaControls, onClick: !disabled && id !== undefined ? () => onChange?.(id) : undefined, onKeyDown: !disabled ? e => onKeyDown(e) : undefined },
        React.createElement(Affix, { dataHook: dataHooks.verticalTabsItemPrefixIcon, size: size, className: st(classes.prefixIcon) }, prefixIcon),
        React.createElement(Text, { className: classes.text, weight: "thin", size: size === 'tiny' ? 'small' : size, dataHook: dataHooks.verticalTabsItemText }, children),
        React.createElement(Affix, { dataHook: dataHooks.verticalTabsItemSuffixIcon, size: size, className: classes.suffixIcon }, suffixIcon)));
};
export { SelectableItem };
//# sourceMappingURL=SelectableItem.js.map